// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4028":"4dfa2e3f2030ae9f","4125":"8bafb32aadba4f53","9365":"009f49b1984624a6","9996":"1a4c6c6d6c7e6b0f"}[chunkId] + ".css";
};